import type { SessionUser } from '~/stores/useMember';

export type TravellerProfile = {
  firstName: string;
  lastName: string;
  phoneCountry: string;
  phone: string;
  nationality: string;
};

export function travellerFirstName(user: SessionUser): string {
  const givenName = user.name?.trim().split(/\s+/)[0];
  const emailName = user.email.split('@')[0].split(/[._-]/)[0];
  const name = givenName || emailName || 'Traveller';
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function travellerDisplayName(user: SessionUser): string {
  const name = user.name?.trim().replace(/\s+/g, ' ');
  if (name) return name;
  const emailName = user.email.split('@')[0].replace(/[._-]+/g, ' ').trim();
  return emailName ? emailName.replace(/\b\w/g, (letter) => letter.toUpperCase()) : 'Traveller';
}

function profileKey(email: string): string {
  return `suitescanner-traveller:${email.trim().toLowerCase()}`;
}

export function loadTravellerProfile(email: string): TravellerProfile | null {
  try {
    const raw = window.localStorage.getItem(profileKey(email));
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<TravellerProfile>;
    if (typeof value.firstName !== 'string' || typeof value.lastName !== 'string' || typeof value.phoneCountry !== 'string' || typeof value.phone !== 'string' || typeof value.nationality !== 'string') return null;
    return value as TravellerProfile;
  } catch {
    return null;
  }
}

export function saveTravellerProfile(email: string, profile: TravellerProfile): boolean {
  try {
    window.localStorage.setItem(profileKey(email), JSON.stringify(profile));
    return true;
  } catch {
    return false;
  }
}
